import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export const opcoesDoImpacto = ({
  getEventImpact,
  user,
  eventId,
  period,
  baseline = null,
  janela = null,
  group = false,
  enabled = true,
}) => {
  const branchId = user?.active_branch_id ?? null;
  return {
    queryKey: [
      "eventImpact",
      user?.user_id ?? null,
      branchId,
      eventId,
      period,
      baseline,
      janela,
      group,
    ],
    queryFn: () =>
      getEventImpact(eventId, {
        period,
        group,
        ...(baseline ? { baseline } : {}),
        ...(janela ? { janela } : {}),
      }),
    enabled: enabled && !!branchId && !!eventId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  };
};

export const opcoesDoImpactoDaTroca = ({
  getCollectionChangeImpact,
  user,
  changeId,
  period,
  baseline = null,
  enabled = true,
}) => {
  const branchId = user?.active_branch_id ?? null;
  return {
    queryKey: [
      "collectionChangeImpact",
      user?.user_id ?? null,
      branchId,
      changeId,
      period,
      baseline,
    ],
    queryFn: () =>
      getCollectionChangeImpact(changeId, {
        period,
        ...(baseline ? { baseline } : {}),
      }),
    enabled: enabled && !!branchId && !!changeId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  };
};

export const opcoesDaSerie = ({
  getEventTimeseries,
  user,
  eventId,
  period,
  baseline = null,
  group = false,
  enabled = true,
}) => {
  const branchId = user?.active_branch_id ?? null;
  return {
    queryKey: [
      "eventTimeseries",
      user?.user_id ?? null,
      branchId,
      eventId,
      period,
      baseline,
      group,
    ],
    queryFn: () =>
      getEventTimeseries(eventId, {
        period,
        group,
        ...(baseline ? { baseline } : {}),
      }),
    enabled: enabled && !!branchId && !!eventId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  };
};

export const opcoesDasSeries = ({
  getEventsTimeseries,
  user,
  eventIds,
  period,
  baseline = null,
  enabled = true,
}) => {
  const branchId = user?.active_branch_id ?? null;
  return {
    queryKey: [
      "eventsTimeseries",
      user?.user_id ?? null,
      branchId,
      eventIds,
      period,
      baseline,
    ],
    queryFn: () =>
      getEventsTimeseries({
        event_id: eventIds,
        period,
        ...(baseline ? { baseline } : {}),
      }),
    enabled: enabled && !!branchId && eventIds?.length > 0,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  };
};

export const opcoesDaSerieDaTroca = ({
  getCollectionChangeTimeseries,
  user,
  changeId,
  period,
  baseline = null,
  enabled = true,
}) => {
  const branchId = user?.active_branch_id ?? null;
  return {
    queryKey: [
      "collectionChangeTimeseries",
      user?.user_id ?? null,
      branchId,
      changeId,
      period,
      baseline,
    ],
    queryFn: () =>
      getCollectionChangeTimeseries(changeId, {
        period,
        ...(baseline ? { baseline } : {}),
      }),
    enabled: enabled && !!branchId && !!changeId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  };
};

export default function useEventImpact({
  eventId,
  period,
  baseline = null,
  janela = null,
  group = false,
  enabled = true,
}) {
  const { getEventImpact } = useApiV2();
  const { user } = useAuth();

  return useQuery(
    opcoesDoImpacto({
      getEventImpact,
      user,
      eventId,
      period,
      baseline,
      janela,
      group,
      enabled,
    })
  );
}
